import { Base } from "./base";
import { getAccessToken } from "../utils/browserStorage";

export class NotificationGroup extends Base {
  /**
   * @description List Location API function
   * @returns {Promise<Response>}
   */
  list(query) {
    let queryParam = new URLSearchParams(query).toString();
    const url = this._getFullURL("/notification-group?" + queryParam);
    return this._secureFetch(url);
  }
  /**
   * @description List Location API function
   * @returns {Promise<Response>}
   */
  getOne(query) {
    let queryParam = new URLSearchParams(query).toString();
    const url = this._getFullURL("/notification-group?" + queryParam);
    return this._secureFetch(url);
  }

  delete(id) {
    const url = this._getFullURL("/notification-group/"+id);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var requestOptions = {
      method: "DELETE",
      headers: myHeaders,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }

  create(payload) {
    const url = this._getFullURL("/notification-group");
    return fetch(
      url,
      this._generateRequestBody({
        payload: payload,
        method: "POST",
      })
    );
  }
  update(id, payload) {
    const url = this._getFullURL("/notification-group?id=" + id);
   
    return fetch(
      url,
      this._generateRequestBody({
        payload: payload,
        method: "PUT",
      })
    );
  }
}
